export default "__VITE_ASSET__CXelGgcA__"